export enum HTTPMethod {
  get = 'GET',
  post = 'POST',
  delete = 'DELETE',
  put = 'PUT',
}
